import generateStore from './generateStore.js'
import humps from 'humps'
import { axios } from '../request'

export default (app) => {
  const url = humps.decamelize('memberApplications')

  const store = generateStore('memberApplications', app)

  store.actions.verifyEmail = (context, { code }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${url}/verifyEmail`, { verificationCode: code })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err.response)
        })
    })
  }
  store.actions.addAsMember = (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${url}/${id}/accept`)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          if (err.response) {
            context.commit('setErrors', { key: 0, payload: err.response.data.errors })
            context.commit('setLastStatus', err.response.status)
            reject(err.response)
          }
        })
    })
  }
  return store
}
